import ApiService from 'src/services/apiService'

type Permissions = {
	canCreate?: boolean
	canEdit?: boolean
	canDelete?: boolean
}

type MasterWorkoutPermissions = {
	canCreate?: boolean
	verifyEdit?: ((isPublic: boolean) => boolean)
	canMakeProgramPublic?: boolean
	canDelete?: boolean
}

export class AdminPermissionsService {
	private static _instance: AdminPermissionsService
	private apiService = ApiService.instance

	public userId: number
	public isAdmin: boolean
	public isAuthor: boolean
	public isWbAdmin: boolean
	public IsWbAuthor: boolean

	public masterExercisePage: Permissions = {
		canCreate: false,
		canEdit: false,
		canDelete: false,
	}
	
	public masterWorkoutPage: MasterWorkoutPermissions = {
		canCreate: false,
		canMakeProgramPublic: false,
		canDelete: false,
		verifyEdit: (isPublic: boolean): boolean => false,
	}

	constructor() {
		this.apiService.getAdminPermissions().then((res) => {
			this.userId = res.userId
			this.isAdmin = res.isAdmin
			this.isAuthor = res.isAuthor
			this.isWbAdmin = res.isWbAdmin
			this.IsWbAuthor = res.isWbAuthor

			this.masterExercisePage = {
				canCreate: this.isAdmin || this.isWbAdmin || this.isAuthor || this.IsWbAuthor,
				canEdit: this.isAdmin || this.isWbAdmin || this.isAuthor || this.IsWbAuthor,
				canDelete: this.isAdmin || this.isWbAdmin,
			}

			this.masterWorkoutPage = {
				canCreate: this.isAdmin || this.isWbAdmin || this.isAuthor || this.IsWbAuthor,
				canMakeProgramPublic: this.isAdmin || this.isWbAdmin,
				canDelete: this.isAdmin || this.isWbAdmin,
				verifyEdit: (isPublic: boolean): boolean => (this.isAdmin || this.isWbAdmin) || ((this.isAuthor || this.IsWbAuthor) && !isPublic),
			}
		})
	}

	public static get instance() {
		if (this._instance) return this._instance
		this._instance = new AdminPermissionsService()
		return this._instance
	}
}
